/* eslint-disable @typescript-eslint/no-require-imports */

export const IllusBerry = require('./quinoa/Illus-Berry.png');
export const IllusFlower = require('./quinoa/Illus-Flower.png');
export const IllusSprout = require('./quinoa/Illus-Sprout.png');
